@if (lastSeen$ | async; as lastSeen) {
  <div>
    <h2>Ostatnio odwiedzione</h2>
    @for (session of lastSeen; track session) {
      <div
    [routerLink]="[
      'private-sessions',
      'edit',
      session.privateSessionId,
      'events'
    ]"
        >
        {{ session.name | langPicker | async }}
      </div>
    }
  </div>
}
<lib-button (click)="addSession()">Dodaj nową</lib-button>
